
export function Progress({
  steps,
  step,
  maxValidated,
  onStepClick,
  includeFirst = true,
  disabled = false,
}: {
  steps: readonly string[];
  step: number;
  maxValidated: number;
  onStepClick: (i: number) => void;
  includeFirst?: boolean;
  disabled?: boolean;
}) {
  const items = steps.map((label, i) => ({ label, i }));
  const visible = includeFirst ? items : items.filter((s) => s.i !== 0);
  return (
    <div className="bg-white border-b border-slate-200 sticky top-0 z-10">
      <div className="max-w-3xl mx-auto px-3 sm:px-4 py-2 sm:py-4 overflow-x-auto">
        <ol className="flex min-w-max items-center justify-center gap-0.5 sm:gap-2">
          {visible.map(({ label, i }, di) => {
            const isActive = i === step;
            const isCompleted = i <= maxValidated;
            const canClick = (isCompleted || isActive) && !disabled;
            const showCheck = isCompleted && !isActive;
            return (
              <li key={label} className="flex items-center gap-0.5 sm:gap-2 shrink-0">
                <button
                  type="button"
                  onClick={() => canClick && onStepClick(i)}
                  disabled={!canClick}
                  aria-current={isActive ? "step" : undefined}
                  className={
                    "flex items-center gap-1.5 rounded-md px-1 py-1 transition sm:gap-2 sm:px-2 " +
                    (canClick ? "cursor-pointer hover:bg-slate-50" : "cursor-not-allowed")
                  }
                >
                  <span
                    className={
                      "size-6 sm:size-7 rounded-full text-xs flex items-center justify-center font-semibold border-2 transition-colors " +
                      (isActive
                        ? "bg-primary text-primary-foreground border-primary"
                        : isCompleted
                          ? "bg-white border-emerald-400 text-emerald-600"
                          : "bg-white border-slate-300 text-slate-400")
                    }
                  >
                    {showCheck ? (
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="3" strokeLinecap="round"
                        strokeLinejoin="round" aria-hidden="true">
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    ) : (
                      di + 1
                    )}
                  </span>
                  <span
                    className={
                      "text-xs sm:text-sm whitespace-nowrap " +
                      (isActive ? "font-semibold text-slate-900" : "hidden sm:inline ") +
                      (isActive ? "" : isCompleted ? "text-slate-700" : "text-slate-400")
                    }
                  >
                    {label}
                  </span>
                </button>
                {i < steps.length - 1 && (
                  <div
                    className={
                      "w-3 sm:w-10 h-px shrink-0 " +
                      (i < maxValidated ? "bg-emerald-300" : "bg-slate-200")
                    }
                    aria-hidden="true"
                  />
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}
